function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.75
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.5 0C7.542 0 5.969 1.627 5.969 3.594V4.031H2C1.449 4.031 1 4.48 1 5.031V6.031H0V8.031H2V23.031C2 24.676 3.355 26.031 5 26.031H17C18.645 26.031 20 24.676 20 23.031V8.031H22V6.031H21V5.031C21 4.48 20.551 4.031 20 4.031H16.031V3.593C16.031 1.627 14.458 0 12.5 0H9.5ZM9.5 2.062H12.5C13.304 2.062 13.969 2.718 13.969 3.593V4.031H8.03V3.593C8.03 2.718 8.695 2.063 9.499 2.063L9.5 2.062ZM4 8.031H9.125C9.249 8.044 9.372 8.062 9.5 8.062H12.5C12.628 8.062 12.75 8.044 12.875 8.031H18V23.031C18 23.594 17.563 24.031 17 24.031H5C4.437 24.031 4 23.594 4 23.031V8.031ZM6 10.031V22.031H8V10.031H6ZM10 10.031V22.031H12V10.031H10ZM14 10.031V22.031H16V10.031H14Z",
  fill: "#757575"
}));

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.547ac25a.svg";
export { ForwardRef as ReactComponent };